import rootProfileSaga from 'pages/profile/profile.saga';
import { all, spawn } from 'redux-saga/effects';
import apiSaga from 'services/api/api.saga';
import rootCmsContentSaga from 'services/cmsContent/cmsContent.saga';
import rootInboxSaga from 'services/inbox/inbox.saga';
import sessionSaga from 'services/session/session.saga';
import vivochaSaga from 'services/vivocha/vivocha.saga';

/**
 * rootSaga
 *
 * Here we inject all the saga that will run in our application.
 */
function* rootSaga() {
  yield all([
    spawn(apiSaga),
    spawn(sessionSaga),
    spawn(rootProfileSaga),
    spawn(rootInboxSaga),
    spawn(rootCmsContentSaga),
    spawn(vivochaSaga),
  ]);
}

export default rootSaga;
